module.exports = __webpack_public_path__ + "img/sec-291-sinyoung.f7e67101.svg";